<template>
    <div>
        {{selectedOs}}
        <div class="row">
           <div class="col-md-6">
                <!-- Select Radio -->
                <div class="sau-select lg center" :class="{selected: selectedOs === 'linux'}">
                    <label for="linux">
                        <input type="radio"  id="linux" value="linux" v-model="selectedOs">
                        <span></span>
                        <img src="/img/linux.gif" alt="Linux">Linux
                    </label>
                </div>
                <!-- Sub Menu Dropdown -->
                <div class="sau-select-sub" :class="{selected: selectedOs === 'linux'}" v-on:click="openMenu" id="linux" ref="linux" tabindex="0" @blur="closeMenu">
                    Select Version <i class="fa fa-chevron-down"></i>
                </div>
                <!-- Dropdown -->
                <div class="sau-menu  text-center d-none w-100">
                    <div class="sau-menu-content w-100">
                        <div v-for="(value, key, index) in dataModel.os.linux" :key="index">
                            <a href="#" @click.prevent="selectVersion(value)">{{ value }}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <!-- Select Radio -->
                <div class="sau-select lg center" :class="{selected: selectedOs === 'windows'}">
                    <label for="windows">
                        <input type="radio"  id="windows" value="windows" v-model="selectedOs">
                        <span></span>
                        <img src="/img/windows.gif" alt="Windows">Windows
                    </label>
                </div>
                <!-- Sub Menu Dropdown -->
                <div class="sau-select-sub" :class="{selected: selectedOs === 'windows'}" v-on:click="openMenu" id="windows" ref="windows" tabindex="0" @blur="closeMenu">
                   {{selectedVersion}}
                    <i class="fa fa-chevron-down"></i>
                </div>
                <!-- Dropdown -->
                <div class="sau-menu selected text-center d-none w-100">
                    <div class="sau-menu-content w-100">

                        <div v-for="(value, key, index) in dataModel.os.windows" :key="index">
                            <a href="#" @click.prevent="selectVersion(value, key)">{{ value }}</a>
                        </div>
                    </div>
                </div>
                {{selectedVersion}}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            selectedOs:'',
            selectedVersion:'Select Version',
            dataModel:{
                os:{
                    linux:['16.04','17.08','18.445'],
                    windows:['Windows XP', 'Windows 8', 'Windows 10']
                }
            }
        }
    },
    methods:{
        openMenu(event){
            event.target.nextElementSibling.classList.toggle('d-none');
        },
        closeMenu(event){
            setTimeout(() => {
                event.target.nextElementSibling.classList.add('d-none');
                }, 200);
        },
        selectVersion(value, index){
            this.selectedVersion = this.dataModel.os.windows[index];
        }
    },
    watch:{
        selectedOs: function(){
            // Select 1st sub menu item when radio is selected
            if(this.selectedVersion === 'Select Version'){
                this.selectedVersion = this.dataModel.os.windows[0];
            }
            //Reset selection if another choice is made
            if(this.selectedOs !== 'windows'){
                this.selectedVersion = 'Select Version'
            }
        }
    }
}

</script>

<style>
.sau-select-sub{
  outline: none;
}




</style>
